<template>
  <div v-if="openModal" class="w-screen h-screen z-40 flex justify-center items-center bottom-0 left-0 fixed bg-gray-400 bg-opacity-80 overflow-auto">
      <loading v-bind:loading="loading" />
      <alert @onFire="eventCloseAlert" v-bind:data_alert="data_alert" />
      <div class="p-4 w-10/12 lg:w-75 md:w-10/12 max-w-lg h-10/12 bg-white rounded-md md:p-10 flex flex-col grid grid-cols-1 mt-10 md:mt-20"> 
          <div>
              <div class="text-right " @click="closeModal()">
                  <span class="cursor-pointer font-bold hover:text-sirit_blue-400">x</span>
              </div>
              <h1 class="text-4xl font-medium mb-3 text-center">Comunicar cobro</h1>
              <div class="w-10/12 flex flex-col items-center mx-auto md:px-1">
                  <span class="md:mb-3 text-md">Si has recibido algún cobro parcial o completo de tu deudor, infórmanos para que podamos gestionar correctamente tu reclamación.</span>
                  <span class="text-md mb-2 sm:mb-3 md:mb-4 xl:mb-8">Importe por reclamar: {{amount}} €</span>
              </div>
          </div>
          <form @submit.prevent="submit">
            <div class="w-full grid grid-cols-1 sm:grid-cols-4 gap-2 text-left">
              <div class="flex flex-col col-span-4">
                  <span class="text-md md:pt-3"><span class="text-sirit_blue-600 font-bold">*</span>Fecha ingreso</span>
                  <Datepicker @internalModelChange="setFactDate()" :autoApply="true" v-model="factDate" locale="es" class="w-full h-full mt-1 md:mt-2 border-black rounded-md border-2" format="dd/MM/yyyy" ></Datepicker>
                </div>
                <div class="flex flex-col col-span-4">
                  <span class="text-md md:pt-3"><span class="text-sirit_blue-600 font-bold">*</span>Importe</span>
                  <div class="w-full flex">
                    <input id="input-company" v-model="dataTransfer.amount" @change="setFormatAmount()"  type="text" autocomplete="off" placeholder="" class="boder border-black w-full h-5 py-5 mt-1 md:mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3" required>
                    <div class="w-1/12 flex items-center justify-center h-5 py-5 mt-2 "><fa icon="euro-sign"/></div>
                  </div>
                   <span v-if="form_.errorAmount" class="text-sirit_blue-500 text-md">El importe no puede ser superior a la deuda</span>
                </div>
                <div class="flex flex-col col-span-4">
                  <span class="text-md md:pt-3"><span class="text-sirit_blue-600 font-bold">*</span>Concepto</span>
                  <input id="input-company" v-model="dataTransfer.concept"  type="text" autocomplete="off" placeholder="" class="boder border-black w-full h-5 py-5 mt-1 md:mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3" required>
                </div>
                <div class="flex flex-col items-end col-span-4 md:pt-3">
                    <button type="submit" :disabled="form_.errorAmount" :class="[form_.errorAmount ? 'bg-gray-300' : 'bg-sirit_blue-500 hover:bg-sirit_blue-600']" class="w-full mt-2 md:mt-4 py-2 md:px-6 text-white rounded-md border-2 font-bold">Notificar</button>
                </div>
            </div>
        </form>
      </div>
  </div>
</template>

<script lang="ts">
import {reactive, toRefs, ref} from 'vue';
import axios from 'axios'
import * as global from '@/api/global'
import {messageVaidate} from '@/api/utilities'
import Alert from '@/components/Commons/Alert.vue'
import Loading from '@/components/Commons/Loading.vue'
import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css'

export default {
name: 'ComunicationModal',
components: {Alert, Loading, Datepicker},
props: {
  openModal: { type: Boolean, required: true, default: false },
  debtorCaseId: { type: Number, required: true, default: 0 },
  lastUpdateDate: { type: String, required: true, default: '' },
  amount: { type: Number, required: true, default: 0 },
},
emits: ['onFire', 'onFireDebts'],
setup (props: any, { emit } : any) {

  const form_ = reactive({
    errorAmount: false,
  });

  interface dates_ {
    factDate: Object
  }

  let dates = reactive<dates_>({
    factDate: ref(new Date()),
  })

  interface comunication {
    day: string,
    month: string,
    year: string,
    loading: boolean
    dataTransfer: {
      debtorCaseId: number,
      amount: string,
      concept: string,
      date: string,
      qualification: string,
      operationDate: string,
    },
    data_alert: {
      title: string,
      msg: string,
      description: string,
      type: string,
      open: boolean,
      field: string
    }
  }

  const initialState  = {
    day: '',
    month: '',
    year: "",
    loading: false,
    dataTransfer: {
      debtorCaseId: 0,
      amount: "0",
      concept: "",
      date: global.getFormatDateComplete(global.getCurrentDate(), 2),
      qualification: "-",
      operationDate: global.getFormatDateComplete(global.getCurrentDate(), 2)
    },
    data_alert:{
      title: "",
      msg: "",
      description: "",
      type: "",
      open: false,
      field: ""
    }
  }

  let data = reactive<comunication>(initialState)

  const resetForm = () => {
    dates.factDate = ref(new Date());
    data.day= '';
    data.month= '';
    data.year= "";
    data.loading= false;
    data.dataTransfer= {
      debtorCaseId: 0,
      amount: "0",
      concept: "",
      date: global.getFormatDateComplete(global.getCurrentDate(), 2),
      qualification: "-",
      operationDate: global.getFormatDateComplete(global.getCurrentDate(), 2)
    }
  }

  const eventCloseAlert = () => {
    data.data_alert.open=false;
  }

  const closeModal = () => {
      resetForm();
      emit("onFire")
  }

  const getDebts = () => {
      emit("onFireDebts")
  }

  const setDate = () => {
    data.dataTransfer.date = global.getFormatDateComplete(data.month+'-'+data.day+'-'+data.year, 2);
    data.dataTransfer.debtorCaseId = props.debtorCaseId;
  }


  const submit = async () => {
    extractPoint();
    data.loading = true;
    const url =  process.env.VUE_APP_BASE_URL+"/Transfer";
    let response = null
    try {
      response = await axios.post(url, data.dataTransfer,  {
          headers: {
              Authorization: `Bearer ${global.getToken()}`
          }
      })
    } catch (e: any) {
        response = e.response || e.request;
    }
    data.loading = false;
    data.data_alert.open=true;

    if(response.status== 200){
      resetForm();
      
      data.data_alert.type = "success";
      data.data_alert.title = "Ok";
      data.data_alert.msg = "Cobro comunicado con éxito";
      data.data_alert.description = ''
      getDebts();
      await setTimeout(function() {
        closeModal();
      }, 2000); 
    }else{
      if(response.status== 401){
        global.logout();
      }
      const msg = response.data.title;
      const arrayErrors = response.data.errors;
      const er = messageVaidate(msg, arrayErrors);
      data.data_alert.type = "danger";
      data.data_alert.title = "¡Error!";
      data.data_alert.msg = response ? "Hubo un problema al tratar de comunicar el cobro" : "No se pudo establecer conexión";
      data.data_alert.description = response.data ? er.length > 0 ? er[0].traduction_es : msg : "No se pudo establecer conexión";
    }
    
      await setTimeout(function() {
        data.data_alert.open=false;
        data.data_alert.type = "";
        data.data_alert.title = "";
        data.data_alert.msg = "";
        data.data_alert.description = ''
      }, 4000); 
  }

  const setFactDate = () => {
    data.dataTransfer.date = global.getFormatDateComplete(dates.factDate, 2);
    data.dataTransfer.debtorCaseId = props.debtorCaseId;
  }

  const setFormatAmount =  () => {
    extractPoint();
    let newAmount = data.dataTransfer.amount;
    newAmount = global.formatAmount(newAmount);
    data.dataTransfer.amount = newAmount.replace(" €", '');
    changeAmount();
  }

  const extractPoint =  (amount:string = '') => {
    let newAmount = data.dataTransfer.amount.replace('.','').replace('.','');
    newAmount = newAmount.replace(',','.');

    if(amount !== ''){
      return newAmount;
    }
    data.dataTransfer.amount = newAmount;
  }

  const changeAmount = () => {
    let totalAmount = Number(extractPoint(data.dataTransfer.amount));

    if(totalAmount > props.amount ){
      form_.errorAmount = true;
    }else{
      form_.errorAmount = false;
    }
  }

  return {
    setFactDate,
    form_,
    changeAmount,
    closeModal,
    submit,
    setDate,
    eventCloseAlert,
    resetForm,
    getDebts,
    messageVaidate,
    setFormatAmount,
    extractPoint,
    ...toRefs(data),
    ...toRefs(dates)
  }

}

}
</script>